import { z } from "zod";
import { ValidationError } from "../errors/ValidationError";
import { dispatchValidationError } from "../errors/errorDispatcher";

export const getCatalogsRequestSchema = z.object({
  vendorId: z
    .union([z.number().int(), z.array(z.number().int())])
    .transform((v) => (Array.isArray(v) ? v[0] : v))
    .optional(),
  limit: z.number().int().positive().optional().default(20),
  offset: z.number().int().min(0).optional().default(0),
});

export const getCatalogImportDetailsRequestSchema = z.object({
  uuidJob: z.any(),
  limit: z.number().int().positive().optional().default(9),
  page: z.number().int().min(0).optional().default(0),
});

export function validateGetCatalogsRequest(data) {
  const parsed = getCatalogsRequestSchema.safeParse(data);
  if (!parsed.success) {
    const message = `Invalid getCatalogs payload: ${parsed.error.message}`;
    dispatchValidationError({ message, issues: parsed.error.issues, raw: parsed.error });
    throw new ValidationError(message, { issues: parsed.error.issues, raw: parsed.error });
  }
  return parsed.data;
}

export function validateGetCatalogImportDetailsRequest(data) {
  const parsed = getCatalogImportDetailsRequestSchema.safeParse(data);
  if (!parsed.success) {
    const message = `Invalid getCatalogImportDetails payload: ${parsed.error.message}`;
    dispatchValidationError({ message, issues: parsed.error.issues, raw: parsed.error });
    throw new ValidationError(message, { issues: parsed.error.issues, raw: parsed.error });
  }
  return parsed.data;
}

